import { render } from "./PasarelaForm.vue?vue&type=template&id=0f39d298&scoped=true"
import script from "./PasarelaForm.vue?vue&type=script&lang=js"
export * from "./PasarelaForm.vue?vue&type=script&lang=js"

import "./PasarelaForm.vue?vue&type=style&index=0&id=0f39d298&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f39d298"]])

export default __exports__